var MBA_TEAMS = [
    { id: "1", name: "Stephanie Peng", picstyle: "url(../../teampage/images/Team/tut_summer04.jpg) -128px 0 no-repeat", title: "Peng" },
    { id: "2", name: "Achani Biaou", picstyle: "url(../../teampage/images/Team/tut_summer04.jpg) 0 0 no-repeat", title: "achani" },
    { id: "3", name: "Jayen", picstyle: "url(../../teampage/images/Team/tut_sabbat02.jpg) -128px -128px no-repeat", title: "jayen" },
    { id: "4", name: "Jasmine Kwok", picstyle: "url(../../teampage/images/Team/tut_sabbat02.jpg) 0 -128px no-repeat", title: "jasmine" },
    { id: "5", name: "Shauntel Poulson", picstyle: "url(../../teampage/images/Team/tut_summer02.jpg) 0 -128px no-repeat", title: "shauntelpoulson" },
    { id: "6", name: "George Igweta", picstyle: "url(../../teampage/images/Team/tut_summer02.jpg) -256px 0 no-repeat", title: "george_igweta" },
];
export default MBA_TEAMS;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/MbaTeam.js